(() => {
  const SECTION_SELECTOR = '[data-hormonize-discount-reveal]';

  class HormonizeDiscountReveal {
    constructor(section) {
      this.section = section;
      this.revealButton = section.querySelector('[data-discount-reveal]');
      this.copyButton = section.querySelector('[data-discount-copy]');
      this.sealedPanel = section.querySelector('[data-discount-panel="sealed"]');
      this.revealedPanel = section.querySelector('[data-discount-panel="revealed"]');
      this.copiedNote = section.querySelector('[data-discount-copied]');
      this.copyLabel = section.querySelector('[data-discount-copy-label]');
      this.code = (section.dataset.discountCode || '').trim();
      this.copyLabelDefault = this.copyLabel?.textContent?.trim() || 'Copy';
      this.copyLabelDone = section.dataset.copyDoneLabel || 'Copied';
      this.copyResetTimer = null;

      this.onReveal = this.onReveal.bind(this);
      this.onCopy = this.onCopy.bind(this);

      this.bind();
    }

    bind() {
      this.revealButton?.addEventListener('click', this.onReveal);
      this.copyButton?.addEventListener('click', this.onCopy);
    }

    async onReveal() {
      if (!this.sealedPanel || !this.revealedPanel) return;

      this.section.classList.add('is-revealed');
      this.sealedPanel.hidden = true;
      this.revealedPanel.hidden = false;

      if (this.revealButton) {
        this.revealButton.setAttribute('aria-expanded', 'true');
      }

      await this.copyCode();
      this.showCopiedFeedback();
    }

    async onCopy() {
      await this.copyCode();
      this.showCopiedFeedback();
      this.flashCopyButton();
    }

    async copyCode() {
      if (!this.code) return false;

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(this.code);
          return true;
        }
      } catch (_error) {
        /* fall through to legacy copy */
      }

      const input = document.createElement('textarea');
      input.value = this.code;
      input.setAttribute('readonly', '');
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      let ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (_error) {
        ok = false;
      }
      document.body.removeChild(input);
      return ok;
    }

    showCopiedFeedback() {
      if (this.copiedNote) {
        this.copiedNote.hidden = false;
      }
    }

    flashCopyButton() {
      if (!this.copyButton) return;

      this.copyButton.classList.add('is-copied');
      if (this.copyLabel) {
        this.copyLabel.textContent = this.copyLabelDone;
      }

      window.clearTimeout(this.copyResetTimer);
      this.copyResetTimer = window.setTimeout(() => {
        this.copyButton.classList.remove('is-copied');
        if (this.copyLabel) {
          this.copyLabel.textContent = this.copyLabelDefault;
        }
      }, 2200);
    }
  }

  const init = (root = document) => {
    root.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      if (section.dataset.discountRevealReady === 'true') return;
      section.dataset.discountRevealReady = 'true';
      new HormonizeDiscountReveal(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) init(event.target);
  });
})();
